module.exports = __webpack_public_path__ + "img/star.f960eb13.svg";